import bugsnag from '@bugsnag/js'
import bugsnagReact from '@bugsnag/plugin-react'
import {library} from '@fortawesome/fontawesome-svg-core'
import {fab} from '@fortawesome/free-brands-svg-icons'
import {far} from '@fortawesome/free-regular-svg-icons'
import {fas} from '@fortawesome/free-solid-svg-icons'
import {AxiosInstance} from "axios"
import {AuctionSettings, Codes, User} from "domain-models"
import Echo from "laravel-echo"
import {PusherConnector} from "laravel-echo/dist/connector"
import React from 'react'
import {render} from 'react-dom'
import {AppState} from "redux/reducers/AppReducer"
import {Router} from 'Router/Router'
import {store} from "./store"

require('./bootstrap')

library.add(fas, fab, far)

declare global {
  interface Window {
    app: AppState,
    Popper: any
    $: JQuery
    jQuery: JQuery
    axios: AxiosInstance
    user: User
    codes: Codes
    settings: AuctionSettings
    Pusher: PusherConnector
    Echo: Echo
    __forceSmoothScrollPolyfill__: boolean
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: any
  }
}

const bugsnagClient = bugsnag({
  apiKey: '51ad3b931c6bce751b3417c9fb5a9535',
  collectUserIp: false,
  appVersion: '1.0.8',
  notifyReleaseStages: ['production', 'staging', window.app.releaseStage],
  releaseStage: window.app.releaseStage || 'local',
  beforeSend: (report) => {
    if (report.errorMessage === 'Request failed with status code 419') report.ignore()
    if (report.errorMessage === 'Request failed with status code 401') report.ignore()
    if (report.errorMessage === 'Error Request failed with status code 401') report.ignore()
    if (report.errorMessage === 'Request failed with status code 422') report.ignore()
    if (report.errorMessage === 'timeout of 0ms exceeded') report.ignore()
    if (report.errorMessage === 'The given data was invalid.') report.ignore()
    if (report.errorMessage === 'Network Error') report.ignore()
    report.updateMetaData('location', location)
    report.errorClass = '[AUCTION] [FRONTEND] ' + report.errorClass + ': ' + report.errorMessage
    report.user = store.getState().user
    report.updateMetaData('filter', store.getState().auctions.filter)
  }
})

bugsnagClient.use(bugsnagReact, React)

const ErrorBoundary = bugsnagClient.getPlugin('react')

render(<ErrorBoundary><Router/></ErrorBoundary>, document.querySelector('#app'))
